import { logger } from '@/utils/log';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { messageRuleCodeMap } from '@/views/config/partner-refer/helper/constant';
import { isEmptyVal, safeJSONParse } from '@/utils';
import { checkPartnerMsgByCondition } from '@/views/config/partner-refer/helper/validator';

const updateElementStyle = ($element, status) => {
  $element && ($element.style.display = (status ? 'block' : 'none'));
};

export default {
  computed: {
    ...mapGetters(['isEligibleForPartner', 'getSelectedPlans', 'partnerRefer', 'showInEligibleMsg', 'partnerReferProductNames', 'getSelectedPlansWithQuantityMap']),
  },
  methods: {
    /// todo will archive --- start
    toggleIneligiblePlanDiscountView(status) {
      const $offerDetailTemplate = this.$refs.offerDetailTemplateRef;
      const $inEligibleElement = $offerDetailTemplate?.querySelector('#partner-ineligible-discount');

      logger.info('$inEligibleElement', $inEligibleElement);

      updateElementStyle($inEligibleElement, status);
    },
    updateEligiblePlanDiscountView() {
      const { eligiblePlanList } = this.partnerRefer?.rules;
      const $offerDetailTemplate = this.$refs.offerDetailTemplateRef;
      const planCodeList = _.keys(this.getSelectedPlansWithQuantityMap);

      const updateElement = (planCode) => {
        const $currentDiscountHead = $offerDetailTemplate?.querySelector(`#${planCode}`);

        logger.info('$currentDiscountHead', $currentDiscountHead, planCodeList);

        $currentDiscountHead && updateElementStyle($currentDiscountHead, this.showInEligibleMsg ? false : _.includes(planCodeList, planCode));
      };

      return _.chain(eligiblePlanList)
        .flatten()
        .uniq()
        .forEach(updateElement)
        .value();
    },
    showAllPromotionPlans() {
      this.toggleIneligiblePlanDiscountView(this.showInEligibleMsg);
      this.updateEligiblePlanDiscountView();
    },
    replaceOfferDetailMsg() { // new template for type(string)
      const $offerDetailTemplate = this.$refs.offerDetailTemplateRef;
      const selectedPlanCodeList = _.keys(this.getSelectedPlansWithQuantityMap);
      const templateElementList = $offerDetailTemplate?.querySelectorAll('.offer-detail-msg-template');

      return _.reduce(templateElementList, (preValid, $template) => {
        const eligibleCountry = $template?.getAttribute('data-eligibleCountry');
        const eligiblePlanList = $template?.getAttribute('data-eligiblePlanList');

        if (preValid) {
          updateElementStyle($template, false);
        } else {
          const messageRuleList = [{
            ruleCode: messageRuleCodeMap.country,
            ruleValue: _.chain(eligibleCountry)
              .split(',')
              .filter((p) => !isEmptyVal(p))
              .value(),
          }, {
            ruleCode: messageRuleCodeMap.planList,
            ruleValue: _.chain(eligiblePlanList)
              .split(',')
              .filter((p) => !isEmptyVal(p))
              .map((p) => p ? safeJSONParse(p, []) : [])
              .value(),
          }];

          preValid = checkPartnerMsgByCondition(messageRuleList, {
            planCodeList: selectedPlanCodeList,
          });

          updateElementStyle($template, preValid);
        }

        return preValid;
      }, false);
    },
  }
}
